<template>
     <div id="setTags">
      <el-dialog title="标签设置" :visible.sync="tagShow" width="20%" style="margin-top: 10%;">
        <div style="color: #108cee;margin-left: 4px;margin-bottom: 5px;cursor: pointer;" @click="newLabels">
          <i class="el-icon-circle-plus-outline" style="margin-right: 2px;"></i>新增标签
        </div>
        <el-checkbox-group v-model="tagcheck" size="mini">
          <el-checkbox-button v-for="item in totalTagsData" :label="item.id" :key="item.id">{{item.name}}</el-checkbox-button>
        </el-checkbox-group>
        <div style="color: #108cee;margin-left: 4px;margin-top: 5px;display: flex;" v-show="addTagInputShow">
          <el-input v-model="addTagInput" placeholder="请输入标签" size="mini" clearable></el-input>
          <i class="el-icon-close" style="line-height: 28px;margin-left: 10px;margin-right: 10px;font-size: 18px;cursor: pointer" @click="addTagInputShow = false"></i>
          <i class="el-icon-check" style="line-height: 28px;font-size: 18px;cursor: pointer" @click="tickSure"></i>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sureTage" size="small">确 定</el-button>
          <el-button @click="tagShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            addTagsOpenid: '', // 微信ID
            addTagInput: '', // 新增标签Input
            addTagInputShow: false,
            tagcheck: [],
            tagShow:false,
            totalTagsData:[]
        }
    },
    created(){
        this.totalTags()
    },
    methods: {
    // 所有标签
      totalTags() {
        fetch({
          url: "hcm/wechat/totalTags",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.totalTagsData = res.data
          }
        })
      },   
     // 确认新增标签
      tickSure() {
        if (this.addTagInput) {
          if (this.addTagInput.length > 30) {
            this.$message({
              message: '标签长度请小于30',
              type: 'warning'
            });
          } else {
            let params={
              name:this.addTagInput
            }
            fetch({
              url: "hcm/wechat/increaseTags",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.$message({
                  message: '新增成功',
                  type: 'success'
                });
                // 所有标签
                this.totalTags()
              } else {
                this.$message.error(res.message);
              }
            })
            this.addTagInputShow = false
          }
        } else {
          this.$message({
            message: '请输入标签',
            type: 'warning'
          });
        }
      },
     // 新增标签
      newLabels() {
        this.addTagInput = ''
        this.addTagInputShow = true
      },
     // 确认添加标签
      sureTage() {
        let params={
          openid: this.addTagsOpenid,
          tagids: this.tagcheck.join(","),
        }
        fetch({
          url: "hcm/wechat/batchtagging",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$emit('theQuery');
            this.$message({
              message: '成功',
              type: 'success'
            });
          } else {
            this.$message.error(res.message);
          }
        })
        this.tagShow = false
      },
         // 添加弹框回显处理
      addTagsfun(tagidList,openid) {
        console.log(tagidList)
        this.addTagsOpenid = openid
        this.addTagInputShow = false
        if (!tagidList.length > 0) {
          this.tagcheck = []
        } else {
          this.tagcheck = []
          if (tagidList) {
            for (var i = 0; i < tagidList.length; i++) {
              this.tagcheck.push(tagidList[i].labelId||tagidList[i].id)
            }
          }
        }
        console.log(this.tagcheck)
        this.tagShow = true
      }
    },
}
</script>
<style lang="scss">
  #setTags{
     .el-checkbox-button:first-child .el-checkbox-button__inner {
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        -webkit-box-shadow: none!important;
        margin: 5px;
        box-shadow: none!important;
      }
      .el-checkbox-button--mini .el-checkbox-button__inner {
        padding: 7px 15px;
        font-size: 12px;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        margin: 5px;
      }
    .el-checkbox-button.is-checked .el-checkbox-button__inner {
      color: #FFF;
      background-color: #409EFF;
      border-color: #409EFF;
      // /* -webkit-box-shadow: -1px 0 0 0 #8cc5ff; */
      // /* box-shadow: -1px 0 0 0 #8cc5ff; */
      }
  }
</style>